import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './Fade.scss';

const transitionProps = {
	classNames: 'fade',
	timeout: { enter: 350, exit: 300 },
};

type TransitionRouteProps = {};

const TransitionRoute = (props: TransitionRouteProps) => <CSSTransition {...transitionProps} {...props} />;

interface Props extends RouteComponentProps {
	children?: React.ReactNode[] | React.ReactNode;
}

const Fade = (props: Props) => {
	const { location, children } = props;
	return (
		<TransitionGroup component={null}>
			{/* @ts-expect-error ts-migrate FIXME */}
			{children && <TransitionRoute key={location.key}>{children}</TransitionRoute>}
		</TransitionGroup>
	);
};

Fade.defaultProps = {
	children: undefined,
};

export default withRouter(Fade);
